import { render, staticRenderFns } from "./Balcony.vue?vue&type=template&id=62056448"
import script from "./Balcony.vue?vue&type=script&lang=js"
export * from "./Balcony.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports